import { Shield, LogOut } from 'lucide-react';
import { Button } from './ui/button';

/**
 * ImpersonationBanner
 * --------------------
 * Persistente banner die bovenaan elke pagina verschijnt wanneer een admin
 * via "Inloggen als" een medewerker-sessie heeft overgenomen.
 *
 * Werkt op basis van localStorage backup-sleutels die EmployeeDetailPage zet:
 *  - admin_token_backup
 *  - admin_user_backup
 *
 * Klik op "Terug naar admin" zet de originele admin-sessie terug en
 * navigeert naar /admin/accounts (medewerkers-overzicht).
 */
const ImpersonationBanner = ({ user }) => {
  const adminBackup = typeof window !== 'undefined'
    ? localStorage.getItem('admin_token_backup')
    : null;

  if (!adminBackup) return null;

  const exitImpersonation = () => {
    try {
      const adminToken = localStorage.getItem('admin_token_backup');
      const adminUser = localStorage.getItem('admin_user_backup');
      if (adminToken && adminUser) {
        localStorage.setItem('token', adminToken);
        localStorage.setItem('user', adminUser);
      }
      localStorage.removeItem('admin_token_backup');
      localStorage.removeItem('admin_user_backup');
    } catch (e) {
      console.error('Exit impersonation failed:', e);
    }
    // Volledige reload zodat de App.js de admin user state oppakt
    window.location.href = '/admin/accounts';
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500 text-white shadow-lg"
      style={{ pointerEvents: 'auto' }}
      data-testid="impersonation-banner"
    >
      <div className="max-w-7xl mx-auto px-3 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Shield className="w-4 h-4 shrink-0" />
          <span className="text-xs sm:text-sm font-medium truncate">
            <span className="hidden sm:inline">Admin Preview · </span>
            Ingelogd als <strong>{user?.name || user?.email || 'medewerker'}</strong>
          </span>
        </div>
        <Button
          size="sm"
          variant="secondary"
          onClick={exitImpersonation}
          className="bg-white/95 hover:bg-white text-orange-700 border-0 shrink-0 h-7 px-2.5 text-xs"
          data-testid="exit-impersonation-btn"
        >
          <LogOut className="w-3.5 h-3.5 mr-1" />
          Terug naar admin
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
